import { Component, Input, OnInit } from "@angular/core";

import { ViewCell } from "ng2-smart-table";
import { PRIORITIES } from "../../@core/data/default-list";

@Component({
  template: `<strong class="text-primary" style="text-align: left;">
    {{ renderValue }}
  </strong>`,
})
export class StbCustomRenderObjectComponent implements ViewCell, OnInit {
  renderValue: string;
  renderCss: string;
  priorities = PRIORITIES;

  @Input() value: string;
  @Input() rowData: any;

  ngOnInit() {
    // console.log("StbCustomRenderObjectComponent/ngOnInit/value:", this.value);
    // console.log(
    //   "StbCustomRenderObjectComponent/ngOnInit/rowData:",
    //   this.rowData
    // );

    if (this.rowData?.objectType) {
      switch (this.rowData.objectType) {
        case "customer":
          this.renderValue = this.rowData.customerName
            ? "KH: " + this.rowData.customerName
            : "";
          break;
        case "supplier":
          this.renderValue = this.rowData.supplierName
            ? "NCC: " + this.rowData.supplierName
            : "";
          break;
        case "employee":
          this.renderValue = this.rowData.employeeName
            ? "NV: " + this.rowData.employeeName
            : "";
          break;

        default:
          this.renderValue = "";
          break;
      }
    }

    // this.renderValue = isNaN(this.value)
    //   ? this.priorities[0].title
    //   : this.priorities[this.value].title;
    // this.renderCss = isNaN(this.value)
    //   ? "text-basic"
    //   : "text-" + this.priorities[this.value].status;
  }
}
